import { UserSettings } from "./UserSettings"

export class UserSettingsState extends UserSettings {
  loading: boolean = false
  areLoaded: boolean = false
}
